import { IS_SSR } from '@src/lib/server-side-rendering'
import React, { ReactNode, useEffect, useState } from 'react'

type SSRGateProps = {
  children?: ReactNode | ReactNode[]
  disableSSR?: boolean
  rerenderOnClientMount?: boolean
}

export const SSRGate: React.FC<SSRGateProps> = props => {
  const [isMounted, setIsMounted] = useState<boolean>(false)

  useEffect(() => {
    if (!isMounted) {
      setIsMounted(true)
    }
  }, [])

  if (props.disableSSR) {
    if (IS_SSR || !isMounted) {
      return <></>
    } else {
      return <>{props.children}</>
    }
  }

  if (props.rerenderOnClientMount) {
    return <React.Fragment key={'client-mount'}>{props.children}</React.Fragment>
  }

  return <>{props.children}</>
}
